import type { DesktopLoginStatus } from './useDesktopTwitterLogin';

type DesktopStatusOverrides = Partial<Record<DesktopLoginStatus, string>>;

const getDefaultStatusLabel = (status: DesktopLoginStatus): string => {
  if (status === 'captured') {
    return 'Twitter cookies captured! Redirecting…';
  }
  if (status === 'error') {
    return 'Twitter login needs attention';
  }
  if (status === 'waiting') {
    return 'Waiting for Twitter authentication…';
  }
  return 'Preparing Twitter login…';
};

const getOverrideLabel = (status: DesktopLoginStatus, overrides?: DesktopStatusOverrides): string | undefined => {
  if (!overrides) {
    return;
  }
  if (status === 'captured' && typeof overrides.captured === 'string') {
    return overrides.captured;
  }
  if (status === 'error' && typeof overrides.error === 'string') {
    return overrides.error;
  }
  if (status === 'waiting' && typeof overrides.waiting === 'string') {
    return overrides.waiting;
  }
  if (status === 'idle' && typeof overrides.idle === 'string') {
    return overrides.idle;
  }
  return;
};

export const getDesktopStatusLabel = (status: DesktopLoginStatus, overrides?: DesktopStatusOverrides): string =>
  getOverrideLabel(status, overrides) ?? getDefaultStatusLabel(status);
